import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import SectionTitle from '../../components/shared/SectionTitle';
import TwoColumns from '../../components/shared/TwoColumns';
import VideoPlayer from '../../components/shared/VideoPlayer';

const CustomerSpotlightSection = () => (
  <Box my="20" px="5">
    <SectionTitle title="Customer Spotlight: Benson Property" />
    <TwoColumns
      maxColWidth="650px"
      col1={
        <VideoPlayer
          title="HOVER - Remote Engagement for Contractors"
          src="https://fast.wistia.net/embed/iframe/n3qgsl9owu"
        />
      }
      col2={
        <Text fontSize="24">
          “We’re no longer upselling to homeowners. Instead, homeowners are
          upselling to themselves. On one job, the insurance company only
          approved the roof repairs. But after seeing the siding options on the
          3D model, the homeowner immediately applied for a loan to repair the
          siding of their house as well. Upselling has never been easier.”
        </Text>
      }
    />
  </Box>
);

export default CustomerSpotlightSection;
